module.exports = __webpack_public_path__ + "img/nounours.c552c016.jpg";